import { useNavigate } from "react-router-dom";

interface AddCompanyButtonProps {
    id?: string;
}

function AddCompanyButton({ id }: AddCompanyButtonProps) {
    const navigate = useNavigate();
    const handleClick = () => {
        if (id) {
            navigate('/companies/addcompany', {state: {id}});
        } else navigate('/companies/addcompany');
    };

    return ( 
        <span className="flex items-center mt-2 md:mt-0">
        <button
            id="add-company"
            onClick={handleClick}
            className="w-40 px-3 mr-4 text-white font-bold text-sm bg-button-blue border border-solid border-button-blue rounded-md focus:outline-none focus:border-blue-500 hover:border-color-cai-blue hover:bg-color-cai-blue h-[36px] appearance-none text-center"
        > + Add Company
        </button>
        </span>
    );
}

export default AddCompanyButton;